export const defaultState = {
  MonitorCard: {
    visible: true,
    order: 1,
    frame: {
      src: 'index.html',
      size: [480, 320]
    }
  },
  ShotCard: {
    visible: false,
    order: 2,
    init: {
      fileName: 'main.js'
    }
  },
  EditorCard: {
    visible: true,
    order: 4,
    init: {
      fileName: 'main.js'
    }
  },
  HierarchyCard: {
    visible: true,
    order: 9
  }
};

export type CardProps = typeof defaultState;
export type CardName = keyof typeof defaultState;
export type SetCardVisibility = (name: CardName, visible?: boolean) => void;
export type CardVisibility = { [name in CardName]?: boolean };
